import { createStructuredSelector } from 'reselect';
import { selectAdvisors, mapData, selectCsrBusinessFunction } from '../../../../../selectors/globalSelectors';
import {
  fetchRAGState,
  selectSelectedCharityName,
  selectSelectedCharityEin,
  selectGrantPurposeName,
  selectGrantRecognition,
  selectGrantAmount,
  selectStartDate,
  selectNoOfPayments,
  selectScheduleType,
  selectAllocationType
} from './RecommendGrantPageSelectors';
import {
  selectCharityId,
  selectCharityAddress,
  selectCharityInterest,
  selectPurposeId,
  selectAdditionalComments,
  selectMissionaryName,
  selectEventName,
  selectMissionaryLocation,
  selectProjectName,
  selectPurposeCertification,
  selectStandardLanguage,
  selectIncludeAdvisorInfo,
  selectHonorOf,
  selectMemoryOf,
  selectNotifyFirstName,
  selectNotifyLastName,
  selectThirdParty,
  selectAccountName,
  selectPublishName,
  selectFrequency,
  selectAllocations,
  selectAllSharesAllPools,
  selectAllShares
} from './ConfirmationPageSelectors';
import { selectPoolsAllocation, selectReGrant, selectInvestmentAllocationDataLoading } from './ScheduleAllocationSelectors';


const selectSubmitLoading = (state) => {
  const { submitLoading } = fetchRAGState(state);
  return submitLoading;
};

const selectAllocExhaustChecked = (state) => {
  const { allocExhaustChecked } = fetchRAGState(state);
  return allocExhaustChecked;
};

export const reviewGrantDerivedStates = createStructuredSelector({
  charityId: selectCharityId,
  charityName: selectSelectedCharityName,
  charityAddress: selectCharityAddress,
  charityEin: selectSelectedCharityEin,
  charityInterest: selectCharityInterest,
  purposeId: selectPurposeId,
  purposeName: selectGrantPurposeName,
  additionalComments: selectAdditionalComments,
  missionaryName: selectMissionaryName,
  eventName: selectEventName,
  missionaryLocation: selectMissionaryLocation,
  projectName: selectProjectName,
  purposeCertification: selectPurposeCertification,
  standardLanguage: selectStandardLanguage,
  grantRecognition: selectGrantRecognition,
  includeAdvisorInfo: selectIncludeAdvisorInfo,
  inHonorOfName: selectHonorOf,
  inMemoryOfName: selectMemoryOf,
  notifyFirstName: selectNotifyFirstName,
  notifyLastName: selectNotifyLastName,
  thirdParty: selectThirdParty,
  accountName: selectAccountName,
  publishName: selectPublishName,
  grantAmount: selectGrantAmount,
  startDate: selectStartDate,
  frequency: selectFrequency,
  noOfPayments: selectNoOfPayments,
  scheduleType: selectScheduleType,
  amountType: selectAllocationType,
  allocations: selectAllocations,
  allSharesAllPools: selectAllSharesAllPools,
  allShares: selectAllShares,
  allocationData: selectPoolsAllocation,
  submitLoading: selectSubmitLoading,
  isRegrantFlow: selectReGrant,
  poolsLoading: selectInvestmentAllocationDataLoading,
  advisors: selectAdvisors,
  codeValueMappingData: mapData,
  csrBusinessFunction: selectCsrBusinessFunction,
  allocExhaustChecked: selectAllocExhaustChecked
});
